import { SlicesContainer } from '@screens/SlicesContainer';
import React from 'react';

const Banners = ({ prismicContent }) => (
  <div className="banner-container">
    <SlicesContainer pageContents={prismicContent} />
    <style jsx>{`
      .banner-container > :global(.container),
      .banner-container :global(.slice-container),
      .banner-container :global(.slice-container-div) {
        min-width: 100%;
        margin: 0;
      }
    `}</style>
  </div>
);

export default Banners;
